import React from 'react';
import styled, { CSSProperties } from 'styled-components';
import Heading from '~ComponentsImproved/Typography/Heading';

const Wrapper = styled.div<{ backgroundColor: string; blinking: boolean }>`
  width: 64px;
  height: 64px;
  overflow: hidden;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  position: relative;
  border-top: 1px solid var(--colorBlueGray1000);
  z-index: 1;
  box-sizing: border-box;

  h6 {
    margin-top: 4px;
    text-align: center;
  }

  &:before {
    content: '';
    background: ${({ backgroundColor }) =>
      backgroundColor ? backgroundColor : 'var(--colorBlueGray1300)'};
    display: ${({ backgroundColor }) => (backgroundColor ? 'block' : 'none')};
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
    animation: fade-in 0.7s infinite alternate-reverse;
  }
`;

export interface Props {
  icon: JSX.Element;
  text?: string;
  textColor?: string;
  onClick: () => void;
  background?: {
    color: string;
    blinking: boolean;
  };
  styles?: CSSProperties;
}

const IconButton = ({ icon, text, textColor, onClick, background, styles }: Props) => {
  return (
    <Wrapper
      style={styles}
      onClick={onClick}
      backgroundColor={background?.color ?? 'transparent'}
      blinking={background?.blinking ?? false}>
      {icon}
      {text && (
        <Heading level={7} color={textColor ?? 'var(--colorBlueGray400)'}>
          {text}
        </Heading>
      )}
    </Wrapper>
  );
};

export default React.memo(IconButton);
